






import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import PromotionBilling from "./PromotionBilling";
const Foodbillingandsetup = () => {
    const { showLoader, hideLoader } = useLoader();

    // Main billing fields
    const billingFields = [
        { label: "Delivery Platform Charges", key: "deliveryplatformCharges" },
        { label: "Delivery Charges", key: "deliveryCharges" },
        { label: "Commission Charges", key: "commissionCharges" },
        { label: "Dinein Platform Charges", key: "dineinPlatformCharges" },
        { label: "Table Platform Charges", key: "tableplatformCharges" },
        { label: "Take away Platform Charges", key: "takeawayplatformCharges" },
        { label: "Coupon Amount Charges", key: "couponAmount" },
        { label: "Promotion Charges", key: "promotionCharge" },
        { label: "Top Rated Charges", key: "topRatedCharge" },
        { label: "Discount Percentage", key: "discountPercentage" },
        { label: "Platform Charges GST", key: "platformchargeGst" },
        { label: "Commission Charges GST", key: "commissionGst" },
        { label: "Packaging Charges GST", key: "packagingChargeGst" },
        { label: "Service Charges GST", key: "serviceChargeGst" },
        { label: "Delivery Radius (KM)", key: "deliveryRadius" },
        { label: "TDS", key: "tds" },
        { label: "Delivery Charges Commission", key: "deiveryChargesCommission" },
    ];

    // Platform threshold and dynamic fields
    const platformThresholdFields = [
        { label: "Delivery Platform Threshold Amount", key: "deliveryPlatformThresholdAmount" },
        { label: "Delivery Platform Charge Below", key: "deliveryPlatformChargeBelow" },
        { label: "Delivery Platform Charge Above", key: "deliveryPlatformChargeAbove" },
        { label: "Dinein Platform Threshold Amount", key: "dineinPlatformThresholdAmount" },
        { label: "Dinein Platform Charge Below", key: "dineinPlatformChargeBelow" },
        { label: "Dinein Platform Charge Above", key: "dineinPlatformChargeAbove" },
        { label: "Table Platform Threshold Amount", key: "tablePlatformThresholdAmount" },
        { label: "Table Platform Charge Below", key: "tablePlatformChargeBelow" },
        { label: "Table Platform Charge Above", key: "tablePlatformChargeAbove" },
        { label: "Takeaway Platform Threshold Amount", key: "takeawayPlatformThresholdAmount" },
        { label: "Takeaway Platform Charge Below", key: "takeawayPlatformChargeBelow" },
        { label: "Takeaway Platform Charge Above", key: "takeawayPlatformChargeAbove" },
    ];

    // Boolean platform settings
    const platformBooleanFields = [
        { label: "Delivery Dynamic Platform Enabled", key: "deliveryDynamicPlatformEnabled" },
        { label: "Delivery Platform Charge Is Percentage", key: "deliveryPlatformChargeIsPercentage" },
        { label: "Dinein Dynamic Platform Enabled", key: "dineinDynamicPlatformEnabled" },
        { label: "Dinein Platform Charge Is Percentage", key: "dineinPlatformChargeIsPercentage" },
        { label: "Table Dynamic Platform Enabled", key: "tableDynamicPlatformEnabled" },
        { label: "Table Platform Charge Is Percentage", key: "tablePlatformChargeIsPercentage" },
        { label: "Takeaway Dynamic Platform Enabled", key: "takeawayDynamicPlatformEnabled" },
        { label: "Takeaway Platform Charge Is Percentage", key: "takeawayPlatformChargeIsPercentage" },
    ];

    // Visibility fields that should be disabled
    const disabledVisibilityFields = [
        "couponAmount",
        "platformchargeGst",
        "commissionGst",
        "packagingChargeGst",
        "serviceChargeGst",
        "promotionCharge",
        "topRatedCharge",
        "discountPercentage",
        "deliveryRadius",
        "tds",
        "deiveryChargesCommission",
        "deliveryPlatformThresholdAmount",
        "deliveryPlatformChargeBelow",
        "deliveryPlatformChargeAbove",
        "dineinPlatformThresholdAmount",
        "dineinPlatformChargeBelow",
        "dineinPlatformChargeAbove",
        "tablePlatformThresholdAmount",
        "tablePlatformChargeBelow",
        "tablePlatformChargeAbove",
        "takeawayPlatformThresholdAmount",
        "takeawayPlatformChargeBelow",
        "takeawayPlatformChargeAbove",
        "deliveryDynamicPlatformEnabled",
        "deliveryPlatformChargeIsPercentage",
        "dineinDynamicPlatformEnabled",
        "dineinPlatformChargeIsPercentage",
        "tableDynamicPlatformEnabled",
        "tablePlatformChargeIsPercentage",
        "takeawayDynamicPlatformEnabled",
        "takeawayPlatformChargeIsPercentage"
    ];

    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);
    const [promotionData, setPromotionData] = useState({});
    const [activeTab, setActiveTab] = useState('billing');

    useEffect(() => {
        const loadData = async () => {
            showLoader();
            await fetchBillingData();
            await fetchPromotionData();
            hideLoader();
        };
        loadData();
    }, []);

    const fetchBillingData = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("❌ Auth token not found in localStorage");
                return;
            }

            const url = `https://backend.maamaas.com/food/api/admin-billing/admin/1`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // Initialize all fields with default values if they don't exist
            const defaultData = {
                id: 1,
                adminId: 1,
                deliveryCharges: 0,
                deliveryChargesVisibility: true,
                deliveryDynamicPlatformEnabled: true,
                deliveryPlatformThresholdAmount: 0,
                deliveryPlatformChargeBelow: 0,
                deliveryPlatformChargeAbove: 0,
                deliveryPlatformChargeIsPercentage: true,
                deliveryplatformChargesVisibility: true,
                dineinDynamicPlatformEnabled: true,
                dineinPlatformThresholdAmount: 0,
                dineinPlatformChargeBelow: 0,
                dineinPlatformChargeAbove: 0,
                dineinPlatformChargeIsPercentage: true,
                dineinPlatformChargesVisibility: true,
                tableDynamicPlatformEnabled: true,
                tablePlatformThresholdAmount: 0,
                tablePlatformChargeBelow: 0,
                tablePlatformChargeAbove: 0,
                tablePlatformChargeIsPercentage: true,
                tableplatformChargesVisibility: true,
                takeawayDynamicPlatformEnabled: true,
                takeawayPlatformThresholdAmount: 0,
                takeawayPlatformChargeBelow: 0,
                takeawayPlatformChargeAbove: 0,
                takeawayPlatformChargeIsPercentage: true,
                takeawayplatformChargesVisibility: true,
                commissionCharges: 0,
                commissionChargesVisibility: true,
                commissionGst: 0,
                couponAmount: 0,
                platformchargeGst: 0,
                packagingChargeGst: 0,
                serviceChargeGst: 0,
                topRatedCharge: 0,
                tds: 0,
                discountPercentage: 0,
                deliveryRadius: 0,
                deiveryChargesCommission: 0,
                promotionCharge: 0
            };

            setBillingData({ ...defaultData, ...response.data });
        } catch (error) {
            console.error("❌ Error fetching billing data:", error);
        }
    };

    const fetchPromotionData = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("❌ Auth token not found in localStorage");
                return;
            }

            const url = `https://backend.maamaas.com/promotions/api/admin/get/billing`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setBillingData(prev => ({
                ...prev,
                promotionCharge: response.data.promotionCharge || prev.promotionCharge
            }));
            setPromotionData(response.data || {});
        } catch (error) {
            console.error("❌ Error fetching promotion data:", error);
        }
    };

    const createPromotionData = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("❌ Auth token not found in localStorage");
                return;
            }

            const payload = {
                promotionCharge: parseFloat(billingData.promotionCharge) || 0
            };

            const url = `https://backend.maamaas.com/promotions/api/admin/create/billing`;
            const response = await axios.post(url, payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            });

            setPromotionData(response.data || {});
            return response.data;
        } catch (error) {
            console.error("❌ Error creating promotion data:", error.response?.data || error.message);
            throw error;
        }
    };

    const updatePromotionData = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("❌ Auth token not found in localStorage");
                return;
            }

            const promotionCharge = parseFloat(billingData.promotionCharge) || 0;
            const url = `https://backend.maamaas.com/promotions/api/admin/update/billing?promotionCharge=${promotionCharge}`;

            const payload = {
                id: promotionData.id || 1,
                promotionCharge: promotionCharge
            };

            const response = await axios.put(url, payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            });

            setPromotionData(response.data || {});
            return response.data;
        } catch (error) {
            console.error("❌ Error updating promotion data:", error.response?.data || error.message);
            throw error;
        }
    };

    const toggleEdit = (key) => {
        setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => ({ ...prev, [key]: value }));
    };

    const handleCheckboxChange = (key) => {
        setBillingData((prev) => ({
            ...prev,
            [`${key}Visibility`]: !prev[`${key}Visibility`]
        }));
    };

    const handleBooleanChange = (key) => {
        setBillingData((prev) => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const handleSave = async (key) => {
        setLoading(true);
        try {
            showLoader();
            const token = localStorage.getItem("authToken");

            // Handle promotion charge separately
            if (key === "promotionCharge") {
                try {
                    await updatePromotionData().catch(async (error) => {
                        if (error.response?.status === 404) {
                            await createPromotionData();
                        } else {
                            throw error;
                        }
                    });
                } catch (promotionError) {
                    console.error("❌ Error saving promotion data:", promotionError);
                    alert(`Failed to save promotion charge: ${promotionError.message}`);
                    return;
                }
            }

            // Save all billing data
            const payload = {
                adminId: 1,
                ...billingData,
            };

            const url = `https://backend.maamaas.com/food/api/admin-billing/add`;
            const response = await axios.post(url, payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            });

            alert("Billing settings saved successfully!");
            if (key) setEditMode((prev) => ({ ...prev, [key]: false }));
            else setEditMode({});
        } catch (error) {
            console.error("❌ Error saving billing data:", error.response?.data || error.message);
            alert(`Failed to save billing settings: ${error.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const renderTable = (fields, showBoolean = false) => (
        <div style={{
            marginTop: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            overflow: 'hidden',
            maxHeight: '450px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Fixed Header */}
            <div style={{
                overflow: 'hidden',
                backgroundColor: '#fff',
                flexShrink: 0
            }}>
                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: 'fixed'
                }}>
                    <thead>
                        <tr>
                            <th style={{ ...headerStyle, width: '400px' }}>Charge Type</th>
                            <th style={{ ...headerStyle, width: '150px' }}>
                                {showBoolean ? 'Status' : 'Value (₹)'}
                            </th>
                            <th style={{ ...headerStyle, width: '100px' }}>Visibility</th>
                            <th style={{ ...headerStyle, width: '100px' }}>Actions</th>
                        </tr>
                    </thead>
                </table>
            </div>

            {/* Scrollable Body */}
            <div style={{
                maxHeight: "325px",
                overflowY: "auto",
                overflowX: 'hidden'
            }}>
                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: 'fixed'
                }}>
                    <tbody>
                        {fields.map(({ label, key }, index) => (
                            <tr key={key} style={{
                                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                            }}>
                                <td style={{ ...cellStyle, width: '400px', textAlign: 'left' }}>
                                    <strong>{label}</strong>
                                </td>
                                <td style={{ ...cellStyle, width: '150px' }}>
                                    {showBoolean ? (
                                        <input
                                            type="checkbox"
                                            checked={billingData[key] || false}
                                            onChange={() => handleBooleanChange(key)}
                                            style={{ transform: 'scale(1.2)' }}
                                        />
                                    ) : (
                                        editMode[key] ? (
                                            <input
                                                type="number"
                                                value={billingData[key] || ""}
                                                onChange={(e) => handleValueChange(key, e.target.value)}
                                                style={inputStyle}
                                                step="0.01"
                                            />
                                        ) : (
                                            <span>{billingData[key] !== undefined ? billingData[key] : "—"}</span>
                                        )
                                    )}
                                </td>
                                <td style={{ ...cellStyle, width: '100px' }}>
                                    <input
                                        type="checkbox"
                                        checked={billingData[`${key}Visibility`] || false}
                                        onChange={() => handleCheckboxChange(key)}
                                        disabled={disabledVisibilityFields.includes(key)}
                                    />
                                </td>
                                <td style={{ ...cellStyle, width: '100px' }}>
                                    {!showBoolean && (
                                        editMode[key] ? (
                                            <FaSave
                                                onClick={() => handleSave(key)}
                                                style={{ ...iconStyle, color: "#4caf50" }}
                                                title="Save"
                                            />
                                        ) : (
                                            <FaEdit
                                                onClick={() => toggleEdit(key)}
                                                style={iconStyle}
                                                title="Edit"
                                            />
                                        )
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    return (
        <div style={containerStyle}>
            {/* Tab Navigation */}
            <div style={tabContainerStyle}>
                <button
                    style={activeTab === 'billing' ? activeTabStyle : tabStyle}
                    onClick={() => setActiveTab('billing')}
                >
                    Billing Charges
                </button>
                <button
                    style={activeTab === 'threshold' ? activeTabStyle : tabStyle}
                    onClick={() => setActiveTab('threshold')}
                >
                    Threshold Settings
                </button>
                <button
                    style={activeTab === 'boolean' ? activeTabStyle : tabStyle}
                    onClick={() => setActiveTab('boolean')}
                >
                    Platform Config
                </button>
                <button
                    style={activeTab === 'promotionBilling' ? activeTabStyle : tabStyle}
                    onClick={() => setActiveTab('promotionBilling')}
                >
                    Promotions Billing
                </button>
            </div>

            {/* Tab Content */}
            {activeTab === 'billing' && renderTable(billingFields, false)}
            {activeTab === 'threshold' && renderTable(platformThresholdFields, false)}
            {activeTab === 'boolean' && renderTable(platformBooleanFields, true)}
            {activeTab === 'promotionBilling' && <PromotionBilling />}
            {/* Save All Button */}
            <div style={buttonContainerStyle}>
                <button
                    onClick={() => handleSave()}
                    disabled={loading}
                    style={loading ? { ...saveButtonStyle, ...disabledButtonStyle } : saveButtonStyle}
                    onMouseOver={e => {
                        if (!loading) e.target.style.backgroundColor = "#45a049";
                    }}
                    onMouseOut={e => {
                        if (!loading) e.target.style.backgroundColor = "#4CAF50";
                    }}
                >
                    {loading ? "Saving..." : "Save All Changes"}
                </button>
            </div>
        </div>
    );
};

// Styles
const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    fontFamily: "Segoe UI, sans-serif",
    padding: "20px"
};

const tabContainerStyle = {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px'
};

const tabStyle = {
    padding: '10px 20px',
    backgroundColor: '#f5f5f5',
    border: 'none',
    borderRadius: '5px 5px 0 0',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#666',
    transition: 'all 0.3s'
};

const activeTabStyle = {
    ...tabStyle,
    backgroundColor: 'rgb(230 109 51)',
    color: '#fff'
};

const headerStyle = {
    background: "rgb(230 109 51)",
    color: "#fff",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold"
};

const cellStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center"
};

const inputStyle = {
    width: "100px",
    padding: "5px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    textAlign: "center"
};

const iconStyle = {
    fontSize: "20px",
    cursor: "pointer",
    margin: "0 5px"
};

const buttonContainerStyle = {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px"
};

const saveButtonStyle = {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s"
};

const disabledButtonStyle = {
    backgroundColor: "#cccccc",
    cursor: "not-allowed"
};

export default Foodbillingandsetup;